/*
 * humo-hero.js — Humo Commerce
 * Слайдер первого экрана (sections/humo-hero.liquid): точки, автопрокрутка, свайп.
 * Автопрокрутка останавливается при наведении/фокусе, при prefers-reduced-motion
 * и навсегда — после ручного переключения. Все слайды уже в разметке, JS только
 * переключает классы/aria (без сдвигов макета).
 */
(function () {
  'use strict';

  var ACTIVE_SLIDE = 'humo-hero__slide--active';
  var ACTIVE_DOT = 'humo-hero__dot--active';
  var SWIPE_MIN = 40;

  function initHero(root) {
    if (root.getAttribute('data-humo-hero-ready') === 'true') return;
    var slides = root.querySelectorAll('[data-humo-hero-slide]');
    var dots = root.querySelectorAll('[data-humo-hero-dot]');
    if (slides.length < 2) return;
    root.setAttribute('data-humo-hero-ready', 'true');

    var current = 0;
    var timer = null;
    var stopped = false;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 7000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;

    function setFocusable(slide, on) {
      var links = slide.querySelectorAll('a');
      Array.prototype.forEach.call(links, function (a) {
        if (on) {
          a.removeAttribute('tabindex');
        } else {
          a.setAttribute('tabindex', '-1');
        }
      });
    }

    function show(index) {
      var next = (index + slides.length) % slides.length;
      if (next === current) return;
      var prevSlide = slides[current];
      var nextSlide = slides[next];

      // Картинка lazy в скрытом слайде может не начать грузиться — подгружаем заранее
      var img = nextSlide.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';

      prevSlide.classList.remove(ACTIVE_SLIDE);
      prevSlide.setAttribute('aria-hidden', 'true');
      setFocusable(prevSlide, false);
      nextSlide.classList.add(ACTIVE_SLIDE);
      nextSlide.removeAttribute('aria-hidden');
      setFocusable(nextSlide, true);

      if (dots[current]) {
        dots[current].classList.remove(ACTIVE_DOT);
        dots[current].setAttribute('aria-selected', 'false');
      }
      if (dots[next]) {
        dots[next].classList.add(ACTIVE_DOT);
        dots[next].setAttribute('aria-selected', 'true');
      }
      current = next;
    }

    function play() {
      if (!autoplay || stopped) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, speed);
    }

    function pause() {
      clearInterval(timer);
    }

    function stop() {
      stopped = true;
      pause();
    }

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        stop();
        show(parseInt(dot.getAttribute('data-humo-hero-dot'), 10));
      });
    });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!root.contains(document.activeElement)) play();
      }, 0);
    });

    // Свайп на тач-экранах
    var startX = null;
    var startY = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
      stop();
      show(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });

    // Вкладка не видна — не крутим
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pause();
      } else {
        play();
      }
    });

    // Редактор темы: выбранный блок-слайд показываем
    root.addEventListener('shopify:block:select', function (e) {
      var index = Array.prototype.indexOf.call(slides, e.target);
      if (index > -1) {
        stop();
        show(index);
      }
    });

    play();
  }

  function init() {
    var roots = document.querySelectorAll('[data-humo-hero]');
    Array.prototype.forEach.call(roots, function (root) {
      try {
        initHero(root);
      } catch (e) {
        console.error('[humo-hero] init failed', e);
      }
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
